export const state = {
  breakpoint: null
}

export const getters = {
  screenSize(state, {}, rootState) {
    if (rootState.editor.screenMode.name) {
      return rootState.editor.screenMode.name
    }

    return state.breakpoint
  },
  allowParallax({}, getters, rootState) {
    return (
      rootState.editor.drawer.type !== 'section-builder' &&
      (getters.screenSize == 'xl' ||
        getters.screenSize == 'lg' ||
        getters.screenSize == 'md')
    )
  }
}

export const actions = {}

export const mutations = {}
